import { emit } from '../bus';
import type { getMainWindow as desktopGetMainWindow } from '../../../src/windows/mainWindow';

/**
 * Masaüstünde servisler arayüze `getMainWindow()?.webContents.send(...)` ile
 * olay gönderiyor. Web'de pencere sayfanın kendisi: gönderilen olaylar veri
 * yoluna (bus.ts) yazılıyor, köprünün `onX` abonelikleri oradan dinliyor.
 */

const webContents = {
  send: (channel: string, ...args: unknown[]) => emit(channel, ...args),
  isDestroyed: () => false,
};

const pageWindow = {
  webContents,
  isDestroyed: () => false,
};

export type PageWebContents = typeof webContents;

export const getMainWindow = (() => pageWindow) as unknown as typeof desktopGetMainWindow;

/** deepgramLive gibi `WebContents` bekleyen servisler için. */
export function pageWebContents(): PageWebContents {
  return webContents;
}
